// Content for Hajj Pre-Registration & Application Requirement pages (EN / BN)

export const PREREG = {
  en: {
    eyebrow: "Hajj 2027 – 2028 · Bangladesh",
    title: "Pre-Register for Hajj 2027 and Secure Your Place",
    subtitle:
      "Pre-registration for Hajj 2027–2028 is officially open. Pay the government fee of BDT 30,000, hand us a copy of your NID or passport, and we take care of the rest — your registration stays valid for two full years.",
    cta_primary: "Pre-Register Today",
    cta_secondary: "Talk to Golam Rabbii",
    fee_label: "Government pre-registration fee",
    fee_per: "per person",
    fee_points: ["Valid for 2 years", "First come, first served", "Refundable as per Govt. policy"],
    open_badge: "Now accepting pre-registrations",
    benefits_eyebrow: "Why register early",
    benefits_title: "The earlier you register, the better your Hajj",
    benefits: [
      { title: "First come, first served", desc: "Seats for Hajj 2027 are allotted strictly by serial. An early serial means an early flight and a confirmed place in our group." },
      { title: "Package details first", desc: "Pre-registered pilgrims are the first to receive our Category A & B pricing, hotel lists and flight windows — before anyone else." },
      { title: "Priority on the best options", desc: "Rooms beside the Haram fill fast. Your serial gives you priority on our best hotels and the shortest Hajj-day routes." },
    ],
    process_eyebrow: "How it works",
    process_title: "Four simple steps — we handle the paperwork",
    steps: [
      { title: "Pay the BDT 30,000 fee", desc: "Bank transfer, bKash/Nagad or cash at our South Banasree office. You get an instant money receipt." },
      { title: "Share your documents", desc: "A clear copy of your NID or passport and an active mobile number. WhatsApp them to us — that's enough." },
      { title: "We register you on e-Hajj", desc: "Our team submits your details to the Ministry's official pre-registration system operated by Business Automation Ltd." },
      { title: "Receive your serial", desc: "You get an official tracking number and SMS confirmation. Your pre-registration stays valid for 2 years." },
    ],
    docs_eyebrow: "Documents checklist",
    docs_title: "What you need to bring",
    docs_note: "Hajj and Umrah are now open to every age — there is no age barrier any more.",
    doc_tabs: [
      { key: "adult", label: "Adult Applicant", items: ["NID or passport copy", "A valid mobile phone number"] },
      { key: "nrb", label: "Non-Resident Bangladeshi", items: ["Passport copy (foreign or Bangladeshi)", "Colour-scanned birth certificate", "Passport-size colour photo (soft copy)", "Valid mobile number and email ID"] },
      { key: "child", label: "Child (with parents)", items: ["Birth certificate or passport copy", "Passport-size colour photo (soft copy)", "Parent's valid mobile number and email ID"] },
    ],
    guide_eyebrow: "Good to know",
    guide_title: "A few things the Ministry asks every pilgrim to remember",
    guidelines: [
      { title: "Pre-registration comes first", desc: "No final booking, visa or flight paperwork can begin until your pre-registration is complete on the official system." },
      { title: "One email, one pilgrim", desc: "Every application must use a unique email address. Emails already used with another agency licence cannot be reused." },
      { title: "Official channel only", desc: "All updates and technical changes are announced on the Hajj official website. We monitor it daily and keep you informed." },
    ],
    form_eyebrow: "Apply now",
    form_title: "Hajj pre-registration application",
    form_sub: "Fill in the form and Golam Rabbii will personally call you within one working day with the next steps and a personalised quote.",
    form: {
      name: "Full name",
      phone: "Mobile number",
      email: "Email address",
      type: "Applicant type",
      types: ["Adult", "Non-Resident Bangladeshi", "Child (with parents)"],
      idno: "NID / Passport number",
      pilgrims: "Number of pilgrims",
      district: "District",
      comments: "Comments (optional)",
      submit: "Submit pre-registration request",
      required: "Fields marked * are required.",
      success_title: "JazakAllahu Khairan!",
      success_sub: "Your request is with us. Expect a call from Golam Rabbii shortly, insha'Allah.",
      another: "Register another pilgrim",
    },
    side_title: "Prefer to talk first?",
    side_sub: "Call or WhatsApp us — we will explain the whole process in five minutes.",
    faq_eyebrow: "Questions",
    faq_title: "Pre-registration FAQs",
    faqs: [
      { q: "Is the BDT 30,000 fee refundable?", a: "Yes. If you are unable to perform Hajj, the government pre-registration fee is refundable through the official process, subject to Ministry rules." },
      { q: "How long does the pre-registration stay valid?", a: "Two years. If you cannot travel in 2027, your serial carries forward to Hajj 2028 without paying again." },
      { q: "Do I need a passport to pre-register?", a: "No. A copy of your NID is enough. You will need a valid passport later, at the final registration stage." },
      { q: "Can my elderly parents or young children register?", a: "Absolutely. There is no longer any age restriction for Hajj or Umrah. Children register with their parents' documents." },
      { q: "Is the fee included in the package price?", a: "Yes — our Hajj 2027 Category A and B prices already include the BDT 30,000 pre-registration. If you registered elsewhere, we deduct it." },
    ],
    cta_title: "Ready to start your journey of a lifetime?",
    cta_sub: "See our Hajj 2027 Category A and Category B packages, or pre-register now and lock in your serial.",
    cta_btn: "View Hajj 2027 Packages",
  },
  bn: {
    eyebrow: "হজ ২০২৭ – ২০২৮ · বাংলাদেশ",
    title: "হজ ২০২৭-এর প্রি-রেজিস্ট্রেশন করুন, আপনার জায়গা নিশ্চিত করুন",
    subtitle:
      "হজ ২০২৭–২০২৮ এর প্রি-রেজিস্ট্রেশন আনুষ্ঠানিকভাবে শুরু হয়েছে। সরকারি ফি ৩০,০০০ টাকা জমা দিন, আপনার NID বা পাসপোর্টের কপি দিন — বাকিটা আমরা সামলে নেব। আপনার রেজিস্ট্রেশন পুরো দুই বছর বৈধ থাকবে।",
    cta_primary: "আজই প্রি-রেজিস্ট্রেশন করুন",
    cta_secondary: "গোলাম রাব্বীর সাথে কথা বলুন",
    fee_label: "সরকারি প্রি-রেজিস্ট্রেশন ফি",
    fee_per: "প্রতি জন",
    fee_points: ["২ বছর বৈধ", "আগে এলে আগে পাবেন", "সরকারি নীতিমালা অনুযায়ী ফেরতযোগ্য"],
    open_badge: "এখন প্রি-রেজিস্ট্রেশন গ্রহণ করা হচ্ছে",
    benefits_eyebrow: "আগে রেজিস্ট্রেশন কেন",
    benefits_title: "যত আগে রেজিস্ট্রেশন, তত সুন্দর হজ",
    benefits: [
      { title: "আগে এলে আগে পাবেন", desc: "হজ ২০২৭-এর আসন কঠোরভাবে সিরিয়াল অনুযায়ী বরাদ্দ হয়। আগের সিরিয়াল মানে আগের ফ্লাইট এবং আমাদের গ্রুপে নিশ্চিত জায়গা।" },
      { title: "প্যাকেজের খবর সবার আগে", desc: "প্রি-রেজিস্টার্ড হাজীরা সবার আগে আমাদের ক্যাটাগরি A ও B এর মূল্য, হোটেল তালিকা ও ফ্লাইট সময় জানতে পারেন।" },
      { title: "সেরা সুবিধায় অগ্রাধিকার", desc: "হারামের পাশের রুম দ্রুত ভরে যায়। আপনার সিরিয়াল আপনাকে আমাদের সেরা হোটেল ও সহজ রুটে অগ্রাধিকার দেয়।" },
    ],
    process_eyebrow: "কিভাবে কাজ করে",
    process_title: "চারটি সহজ ধাপ — কাগজপত্র আমরা সামলাই",
    steps: [
      { title: "৩০,০০০ টাকা ফি জমা দিন", desc: "ব্যাংক ট্রান্সফার, বিকাশ/নগদ অথবা আমাদের দক্ষিণ বনশ্রী অফিসে নগদে। সাথে সাথে মানি রিসিট পাবেন।" },
      { title: "ডকুমেন্ট দিন", desc: "NID বা পাসপোর্টের স্পষ্ট কপি এবং সচল মোবাইল নম্বর। হোয়াটসঅ্যাপে পাঠালেই যথেষ্ট।" },
      { title: "আমরা ই-হজে রেজিস্ট্রেশন করি", desc: "আমাদের টিম ধর্ম মন্ত্রণালয়ের অফিসিয়াল প্রি-রেজিস্ট্রেশন সিস্টেমে (বিজনেস অটোমেশন লিমিটেড পরিচালিত) আপনার তথ্য জমা দেয়।" },
      { title: "সিরিয়াল পান", desc: "আপনি অফিসিয়াল ট্র্যাকিং নম্বর ও SMS নিশ্চয়তা পাবেন। প্রি-রেজিস্ট্রেশন ২ বছর বৈধ থাকবে।" },
    ],
    docs_eyebrow: "ডকুমেন্ট চেকলিস্ট",
    docs_title: "যা যা লাগবে",
    docs_note: "এখন যেকোনো বয়সে হজ এবং উমরাহ করা যায়, বয়সের কোনো বাঁধা আর নাই।",
    doc_tabs: [
      { key: "adult", label: "প্রাপ্তবয়স্ক আবেদনকারী", items: ["NID / পাসপোর্টের কপি", "সচল মোবাইল ফোন নম্বর"] },
      { key: "nrb", label: "প্রবাসী বাংলাদেশি (NRB)", items: ["পাসপোর্টের কপি (বিদেশি/বাংলাদেশি)", "জন্ম সনদের রঙিন স্ক্যান কপি", "পাসপোর্ট সাইজ রঙিন ছবি (সফট কপি)", "সচল মোবাইল নম্বর ও ইমেইল আইডি"] },
      { key: "child", label: "শিশু (অভিভাবকের সাথে)", items: ["জন্ম সনদ / পাসপোর্টের কপি", "পাসপোর্ট সাইজ রঙিন ছবি (সফট কপি)", "অভিভাবকের সচল মোবাইল নম্বর ও ইমেইল আইডি"] },
    ],
    guide_eyebrow: "জেনে রাখা ভালো",
    guide_title: "মন্ত্রণালয় প্রতিটি হাজীকে যা মনে রাখতে বলে",
    guidelines: [
      { title: "প্রি-রেজিস্ট্রেশন সবার আগে", desc: "অফিসিয়াল সিস্টেমে প্রি-রেজিস্ট্রেশন সম্পন্ন না হলে চূড়ান্ত বুকিং, ভিসা বা ফ্লাইটের কোনো কাজ শুরু করা যায় না।" },
      { title: "এক ইমেইল, এক হাজী", desc: "প্রতিটি আবেদনে আলাদা ইমেইল ঠিকানা ব্যবহার করতে হয়। অন্য এজেন্সি লাইসেন্সে ব্যবহৃত ইমেইল পুনরায় ব্যবহার করা যায় না।" },
      { title: "শুধু অফিসিয়াল চ্যানেল", desc: "সব আপডেট ও পরিবর্তন হজ অফিসিয়াল ওয়েবসাইটে ঘোষণা করা হয়। আমরা প্রতিদিন নজর রাখি এবং আপনাকে জানাই।" },
    ],
    form_eyebrow: "এখনই আবেদন করুন",
    form_title: "হজ প্রি-রেজিস্ট্রেশন আবেদন",
    form_sub: "ফর্মটি পূরণ করুন, গোলাম রাব্বী নিজে এক কর্মদিবসের মধ্যে আপনাকে ফোন করে পরবর্তী ধাপ ও ব্যক্তিগত কোটেশন জানাবেন।",
    form: {
      name: "পূর্ণ নাম",
      phone: "মোবাইল নম্বর",
      email: "ইমেইল ঠিকানা",
      type: "আবেদনকারীর ধরন",
      types: ["প্রাপ্তবয়স্ক", "প্রবাসী বাংলাদেশি", "শিশু (অভিভাবকের সাথে)"],
      idno: "NID / পাসপোর্ট নম্বর",
      pilgrims: "হাজীর সংখ্যা",
      district: "জেলা",
      comments: "মন্তব্য (ঐচ্ছিক)",
      submit: "প্রি-রেজিস্ট্রেশন অনুরোধ পাঠান",
      required: "* চিহ্নিত ঘরগুলো আবশ্যক।",
      success_title: "জাযাকাল্লাহু খাইরান!",
      success_sub: "আপনার অনুরোধ আমাদের কাছে পৌঁছেছে। ইনশাআল্লাহ শিগগিরই গোলাম রাব্বী আপনাকে ফোন করবেন।",
      another: "আরেকজন হাজী রেজিস্টার করুন",
    },
    side_title: "আগে কথা বলতে চান?",
    side_sub: "কল বা হোয়াটসঅ্যাপ করুন — পাঁচ মিনিটে পুরো প্রক্রিয়া বুঝিয়ে দেব।",
    faq_eyebrow: "প্রশ্নোত্তর",
    faq_title: "প্রি-রেজিস্ট্রেশন সম্পর্কে সাধারণ প্রশ্ন",
    faqs: [
      { q: "৩০,০০০ টাকা ফি ফেরতযোগ্য কি?", a: "হ্যাঁ। হজ করতে না পারলে সরকারি প্রি-রেজিস্ট্রেশন ফি মন্ত্রণালয়ের নিয়ম অনুযায়ী অফিসিয়াল প্রক্রিয়ায় ফেরত পাওয়া যায়।" },
      { q: "প্রি-রেজিস্ট্রেশন কতদিন বৈধ?", a: "দুই বছর। ২০২৭-এ যেতে না পারলে আপনার সিরিয়াল নতুন ফি ছাড়াই হজ ২০২৮-এ চলে যাবে।" },
      { q: "প্রি-রেজিস্ট্রেশনে পাসপোর্ট লাগবে কি?", a: "না। NID-এর কপিই যথেষ্ট। চূড়ান্ত রেজিস্ট্রেশনের সময় বৈধ পাসপোর্ট লাগবে।" },
      { q: "বয়স্ক বাবা-মা বা ছোট শিশু রেজিস্ট্রেশন করতে পারবে?", a: "অবশ্যই। হজ ও উমরাহতে এখন আর বয়সের কোনো বাধা নেই। শিশুরা অভিভাবকের ডকুমেন্ট দিয়ে রেজিস্ট্রেশন করে।" },
      { q: "এই ফি প্যাকেজ মূল্যে অন্তর্ভুক্ত?", a: "হ্যাঁ — আমাদের হজ ২০২৭ ক্যাটাগরি A ও B মূল্যে ৩০,০০০ টাকা প্রি-রেজিস্ট্রেশন অন্তর্ভুক্ত। অন্য কোথাও রেজিস্ট্রেশন করে থাকলে সেটা বাদ যাবে।" },
    ],
    cta_title: "জীবনের সেরা সফর শুরু করতে প্রস্তুত?",
    cta_sub: "আমাদের হজ ২০২৭ ক্যাটাগরি A ও B প্যাকেজ দেখুন, অথবা এখনই প্রি-রেজিস্ট্রেশন করে সিরিয়াল নিশ্চিত করুন।",
    cta_btn: "হজ ২০২৭ প্যাকেজ দেখুন",
  },
};

export const REQUIREMENTS = {
  en: {
    eyebrow: "Hajj 2027 / 2028 · Application guide",
    title: "Hajj Application Requirements — the complete checklist from Bangladesh",
    subtitle:
      "The right paperwork is the first step of a peaceful Hajj. Here is everything a Bangladeshi pilgrim needs — documents, eligibility, the step-by-step process and the questions we get asked every day.",
    cta_primary: "Pre-Register for Hajj 2027",
    cta_secondary: "Contact us for Hajj visa",
    docs_eyebrow: "Required documents",
    docs_title: "Five things to keep ready",
    docs: [
      { title: "Valid passport", desc: "At least 12 months validity from the date of application, with blank pages for the visa." },
      { title: "Two PP-size photos", desc: "Recent colour photographs on a white background — no glasses, no cap." },
      { title: "Active mobile number", desc: "A local number that stays on. The Ministry and our team will send SMS updates here." },
      { title: "Active email address", desc: "A unique, working email for the e-Hajj system. One email per pilgrim." },
      { title: "GO / NOC", desc: "Government Order or No Objection Certificate — only if you are a government employee." },
    ],
    steps_eyebrow: "The process",
    steps_title: "How to apply for Hajj from Bangladesh",
    steps_sub: "Seven clear steps. At every one of them, Fly Jannah is beside you.",
    steps: [
      { title: "Pre-register with an approved agency", desc: "Pay BDT 30,000 and submit your NID/passport copy through a government-licensed agency like Fly Jannah." },
      { title: "Complete the application form", desc: "We fill the Ministry's official form with you, double-checking every spelling against your passport." },
      { title: "Provide the required documents", desc: "Passport, photos, mobile and email — plus GO/NOC if applicable." },
      { title: "Submit biometric data", desc: "Fingerprints and photo at the designated centre. We book your slot and accompany you." },
      { title: "Receive registration confirmation", desc: "Your final registration is confirmed with a PID and official SMS." },
      { title: "Follow Ministry instructions", desc: "Vaccinations, training sessions and payment schedules — we remind you of every deadline." },
      { title: "Collect your visa", desc: "Your Hajj visa is issued and handed over with your flight details and Ihram kit." },
    ],
    elig_eyebrow: "Eligibility",
    elig_title: "Who can apply for a Hajj visa?",
    eligibility: [
      { title: "Muslim faith", desc: "Hajj is a pilgrimage exclusively for Muslims; the applicant must be a practising Muslim." },
      { title: "Any age", desc: "No age limit applies. Minors must travel with a parent or legal guardian." },
      { title: "Good health", desc: "Free of infectious diseases that could endanger fellow pilgrims; fit for the physical rites." },
      { title: "Valid passport", desc: "At least six months beyond your planned departure — we recommend twelve." },
      { title: "Financial capability", desc: "Able to cover the full cost of the package and personal expenses." },
      { title: "Sincere intention", desc: "A genuine intention to perform Hajj and seek Allah's forgiveness and blessing." },
      { title: "Accompanying non-Muslims", desc: "Non-Muslim family members may apply for a special visa to accompany Muslim relatives." },
    ],
    wc_eyebrow: "Women & children",
    wc_title: "Special guidelines for women and children",
    women_title: "Women's Hajj visa",
    women: ["Women of all ages can apply for a Hajj visa.", "Women under 45 must be accompanied by a Mahram.", "Women over 45 may travel without a Mahram as part of an organised group like ours."],
    children_title: "Children's Hajj visa",
    children: ["Children of every age need their own Hajj visa.", "Minors under 18 must be accompanied by a parent or legal guardian."],
    mahram_title: "Mahram consent letter",
    mahram: "For women travelling without a Mahram, a notarised consent letter signed by the authorised male guardian (father, brother, son) is required, granting permission to perform Hajj with the travel group. We provide the template and help with notarisation.",
    tips_eyebrow: "Our advice",
    tips_title: "Nine tips for a smooth Hajj visa",
    tips: ["Apply early", "Choose a licensed agency", "Keep documents accurate", "Comply with regulations", "Be financially prepared", "Stay updated", "Patience & flexibility", "Consult with experts", "Follow up regularly"],
    faq_eyebrow: "FAQ",
    faq_title: "Frequently asked questions about Hajj visa requirements",
    faqs: [
      { q: "What documents are required for a Hajj visa application?", a: "A valid passport, completed application form, vaccination records, PP-size photographs and — for government employees — a GO/NOC. Your agency handles the certificate of eligibility." },
      { q: "Are there specific eligibility criteria?", a: "Yes: being a practising Muslim, good health, a valid passport and the financial means to cover pilgrimage expenses." },
      { q: "What health requirements are needed?", a: "Proof of vaccination against meningitis (ACWY) and polio is mandatory; seasonal flu and COVID-19 vaccines are strongly recommended." },
      { q: "Can I apply for a Hajj visa individually?", a: "Bangladeshi pilgrims apply through the government or a licensed private agency. Fly Jannah registers you as part of our group and handles every step." },
      { q: "When should I apply?", a: "As early as possible — pre-registration serials decide who travels. Quotas fill quickly every year." },
      { q: "Can non-Muslims enter Saudi Arabia during Hajj?", a: "Non-Muslims cannot enter Makkah and Madinah during Hajj season without special permits." },
    ],
    cta_title: "Have your documents ready? Let's begin.",
    cta_sub: "Pre-register for Hajj 2027 today, or send us a photo of your passport on WhatsApp and we will check it for you — free.",
    cta_btn: "Start Pre-Registration",
  },
  bn: {
    eyebrow: "হজ ২০২৭ / ২০২৮ · আবেদন গাইড",
    title: "হজ আবেদনের শর্তাবলী — বাংলাদেশ থেকে সম্পূর্ণ চেকলিস্ট",
    subtitle:
      "সঠিক কাগজপত্রই নির্ঝঞ্ঝাট হজের প্রথম ধাপ। বাংলাদেশি হাজীর যা যা লাগবে — ডকুমেন্ট, যোগ্যতা, ধাপে ধাপে প্রক্রিয়া এবং প্রতিদিন যে প্রশ্নগুলো আমরা শুনি — সব এখানে।",
    cta_primary: "হজ ২০২৭ প্রি-রেজিস্ট্রেশন",
    cta_secondary: "হজ ভিসার জন্য যোগাযোগ করুন",
    docs_eyebrow: "প্রয়োজনীয় ডকুমেন্ট",
    docs_title: "পাঁচটি জিনিস প্রস্তুত রাখুন",
    docs: [
      { title: "বৈধ পাসপোর্ট", desc: "আবেদনের তারিখ থেকে কমপক্ষে ১২ মাস মেয়াদ, ভিসার জন্য খালি পাতাসহ।" },
      { title: "দুই কপি PP সাইজ ছবি", desc: "সাদা ব্যাকগ্রাউন্ডে সম্প্রতি তোলা রঙিন ছবি — চশমা বা টুপি ছাড়া।" },
      { title: "সচল মোবাইল নম্বর", desc: "সব সময় চালু থাকে এমন দেশীয় নম্বর। মন্ত্রণালয় ও আমাদের টিম এখানে SMS পাঠাবে।" },
      { title: "সচল ইমেইল ঠিকানা", desc: "ই-হজ সিস্টেমের জন্য একটি আলাদা, কার্যকর ইমেইল। প্রতি হাজীর জন্য একটি।" },
      { title: "GO / NOC", desc: "সরকারি আদেশ বা অনাপত্তি সনদ — শুধুমাত্র সরকারি চাকরিজীবীদের জন্য।" },
    ],
    steps_eyebrow: "প্রক্রিয়া",
    steps_title: "বাংলাদেশ থেকে হজের আবেদন কিভাবে করবেন",
    steps_sub: "সাতটি স্পষ্ট ধাপ। প্রতিটি ধাপে ফ্লাই জান্নাহ আপনার পাশে।",
    steps: [
      { title: "অনুমোদিত এজেন্সিতে প্রি-রেজিস্ট্রেশন", desc: "ফ্লাই জান্নাহর মতো সরকার-লাইসেন্সপ্রাপ্ত এজেন্সির মাধ্যমে ৩০,০০০ টাকা জমা দিয়ে NID/পাসপোর্ট কপি দিন।" },
      { title: "আবেদন ফর্ম পূরণ", desc: "মন্ত্রণালয়ের অফিসিয়াল ফর্ম আমরা আপনার সাথে বসে পূরণ করি, পাসপোর্টের সাথে প্রতিটি বানান মিলিয়ে।" },
      { title: "প্রয়োজনীয় ডকুমেন্ট জমা", desc: "পাসপোর্ট, ছবি, মোবাইল ও ইমেইল — প্রযোজ্য হলে GO/NOC।" },
      { title: "বায়োমেট্রিক প্রদান", desc: "নির্ধারিত কেন্দ্রে ফিঙ্গারপ্রিন্ট ও ছবি। আমরা আপনার স্লট বুক করি এবং সাথে থাকি।" },
      { title: "রেজিস্ট্রেশন নিশ্চয়তা", desc: "PID ও অফিসিয়াল SMS-এর মাধ্যমে আপনার চূড়ান্ত রেজিস্ট্রেশন নিশ্চিত হয়।" },
      { title: "মন্ত্রণালয়ের নির্দেশনা অনুসরণ", desc: "টিকা, প্রশিক্ষণ ও পেমেন্ট সময়সূচি — প্রতিটি ডেডলাইন আমরা মনে করিয়ে দেই।" },
      { title: "ভিসা সংগ্রহ", desc: "আপনার হজ ভিসা ইস্যু হয় এবং ফ্লাইটের তথ্য ও ইহরাম কিটসহ হাতে তুলে দেওয়া হয়।" },
    ],
    elig_eyebrow: "যোগ্যতা",
    elig_title: "হজ ভিসার জন্য কে আবেদন করতে পারবেন?",
    eligibility: [
      { title: "মুসলিম হওয়া", desc: "হজ কেবল মুসলমানদের জন্য; আবেদনকারীকে ধর্মপ্রাণ মুসলিম হতে হবে।" },
      { title: "যেকোনো বয়স", desc: "বয়সের কোনো সীমা নেই। অপ্রাপ্তবয়স্কদের অভিভাবকের সাথে যেতে হবে।" },
      { title: "সুস্বাস্থ্য", desc: "অন্য হাজীদের জন্য ঝুঁকিপূর্ণ সংক্রামক রোগমুক্ত; শারীরিক ইবাদতের জন্য সক্ষম।" },
      { title: "বৈধ পাসপোর্ট", desc: "যাত্রার তারিখ থেকে কমপক্ষে ছয় মাস মেয়াদ — আমরা বারো মাস রাখার পরামর্শ দেই।" },
      { title: "আর্থিক সক্ষমতা", desc: "প্যাকেজের সম্পূর্ণ খরচ ও ব্যক্তিগত ব্যয় বহনে সক্ষম।" },
      { title: "খাঁটি নিয়ত", desc: "হজ আদায় ও আল্লাহর ক্ষমা ও রহমত প্রার্থনার আন্তরিক নিয়ত।" },
      { title: "সঙ্গী অমুসলিম", desc: "মুসলিম আত্মীয়ের সাথে যেতে অমুসলিম পরিবারের সদস্যরা বিশেষ ভিসার আবেদন করতে পারেন।" },
    ],
    wc_eyebrow: "নারী ও শিশু",
    wc_title: "নারী ও শিশুদের জন্য বিশেষ নির্দেশনা",
    women_title: "নারীদের হজ ভিসা",
    women: ["সব বয়সের নারী হজ ভিসার আবেদন করতে পারেন।", "৪৫ বছরের কম বয়সী নারীদের মাহরাম সাথে থাকতে হবে।", "৪৫ বছরের বেশি বয়সী নারী আমাদের মতো সংগঠিত গ্রুপের সাথে মাহরাম ছাড়া যেতে পারেন।"],
    children_title: "শিশুদের হজ ভিসা",
    children: ["প্রতিটি বয়সের শিশুর নিজস্ব হজ ভিসা লাগে।", "১৮ বছরের কম বয়সীদের অভিভাবকের সাথে থাকতে হবে।"],
    mahram_title: "মাহরামের সম্মতিপত্র",
    mahram: "মাহরাম ছাড়া ভ্রমণকারী নারীদের জন্য অনুমোদিত পুরুষ অভিভাবকের (বাবা, ভাই, ছেলে) স্বাক্ষরিত নোটারাইজড সম্মতিপত্র লাগে, যাতে ভ্রমণ গ্রুপের সাথে হজ আদায়ের অনুমতি থাকে। আমরা নমুনা দেই এবং নোটারিতে সহায়তা করি।",
    tips_eyebrow: "আমাদের পরামর্শ",
    tips_title: "নির্ঝঞ্ঝাট হজ ভিসার নয়টি টিপস",
    tips: ["আগে আবেদন করুন", "লাইসেন্সপ্রাপ্ত এজেন্সি বেছে নিন", "ডকুমেন্ট নির্ভুল রাখুন", "নিয়ম মেনে চলুন", "আর্থিকভাবে প্রস্তুত থাকুন", "আপডেট থাকুন", "ধৈর্য ও নমনীয়তা", "বিশেষজ্ঞের পরামর্শ নিন", "নিয়মিত ফলো-আপ করুন"],
    faq_eyebrow: "প্রশ্নোত্তর",
    faq_title: "হজ ভিসার শর্ত সম্পর্কে সাধারণ প্রশ্ন",
    faqs: [
      { q: "হজ ভিসা আবেদনে কী কী ডকুমেন্ট লাগে?", a: "বৈধ পাসপোর্ট, পূরণকৃত আবেদন ফর্ম, টিকার রেকর্ড, PP সাইজ ছবি এবং সরকারি চাকরিজীবীদের জন্য GO/NOC। যোগ্যতার সনদ এজেন্সি সামলায়।" },
      { q: "নির্দিষ্ট যোগ্যতার শর্ত আছে?", a: "হ্যাঁ: ধর্মপ্রাণ মুসলিম হওয়া, সুস্বাস্থ্য, বৈধ পাসপোর্ট এবং হজের খরচ বহনের আর্থিক সক্ষমতা।" },
      { q: "স্বাস্থ্যগত শর্ত কী?", a: "মেনিনজাইটিস (ACWY) ও পোলিও টিকার প্রমাণ বাধ্যতামূলক; মৌসুমি ফ্লু ও কোভিড-১৯ টিকা জোরালোভাবে সুপারিশকৃত।" },
      { q: "একা হজ ভিসার আবেদন করা যায়?", a: "বাংলাদেশি হাজীরা সরকারি বা লাইসেন্সপ্রাপ্ত বেসরকারি এজেন্সির মাধ্যমে আবেদন করেন। ফ্লাই জান্নাহ আপনাকে গ্রুপে রেজিস্টার করে প্রতিটি ধাপ সামলায়।" },
      { q: "কখন আবেদন করা উচিত?", a: "যত দ্রুত সম্ভব — প্রি-রেজিস্ট্রেশন সিরিয়ালই নির্ধারণ করে কে যাবে। কোটা প্রতি বছর দ্রুত পূর্ণ হয়।" },
      { q: "হজের সময় অমুসলিম সৌদি আরবে প্রবেশ করতে পারে?", a: "বিশেষ অনুমতি ছাড়া হজ মৌসুমে অমুসলিমরা মক্কা ও মদিনায় প্রবেশ করতে পারেন না।" },
    ],
    cta_title: "ডকুমেন্ট প্রস্তুত? তাহলে শুরু করা যাক।",
    cta_sub: "আজই হজ ২০২৭ প্রি-রেজিস্ট্রেশন করুন, অথবা হোয়াটসঅ্যাপে পাসপোর্টের ছবি পাঠান — আমরা বিনামূল্যে যাচাই করে দেব।",
    cta_btn: "প্রি-রেজিস্ট্রেশন শুরু করুন",
  },
};
